import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Loading from '../components/Loading';
import DefaultLayout from '../layout/DefaultLayout';
import { DeudaAfiliado } from '../models/Payments';
import paymentService from '../services/paymentService';
import userService from '../services/userService';
import colegioService from '../services/ColegioService';
import { useGlobalState } from '../state';
import { toCurrency } from '../utils/formaters';
import CredencialImg from '../images/credencial.png';
import TramiteButton from '../components/TramiteButton';
import { FaMoneyCheckAlt, FaUpload, FaMapMarkedAlt, FaGift, FaPhone, FaPiggyBank, FaIdCard, FaFile, FaTicketAlt } from 'react-icons/fa';
import { CongresosHomeWidget } from '../modules/congreso';


const Home: React.FC = () => {
    const navigate = useNavigate()

    const [user, setUser] = useGlobalState('user')
    const [loading, setLoading] = useState<boolean>(true)
    const [deudaAfiliado, setDeudaAfiliado] = useState<DeudaAfiliado | undefined>(undefined)
    const [existenPagosPendientesImputacion, setExistenPagosPendientesImputacion] = useState<boolean>(false)
    const [beneficio, setBeneficio] = useState<any>(undefined)
    const [errorText, setError] = useState<string | undefined>(undefined)
    const [showCredentialModal, setShowCredentialModal] = useState<boolean>(false);

    // Sólo redirigir cuando ya se haya determinado el estado de autenticación.
    //useEffect(() => {
    //    // Si user === undefined => todavía no se verificó (esperar).
    //    if (user === undefined) return;
    //    if (!user) navigate("/auth/signin");
    //}, [user, navigate]);

    useEffect(() => {

        const fetchData = async () => {
            setLoading(true);

            userService.getDatosDinamicos(true).then(
                (result: any) => {
                    if (result.success) {
                        if (typeof result.data.deuda?.montoTotal === 'number') {
                            setDeudaAfiliado(result.data.deuda);
                        }
                        const afiliadoData = result.data.afiliado ?? result.data.Afiliado;
                        setUser((prev: any) => ({
                            ...prev,
                            datosUsuario: afiliadoData,
                            user: {
                                ...prev?.user,
                                datosUsuario: afiliadoData
                            }
                        }));
                    } else {
                        setError(result.errors[0]);
                    }
                }
            ).finally(() => setLoading(false));

            userService.getBeneficios().then(
                (result: any) => {
                    if (result.success) {
                        let data = JSON.parse(result.data)
                        if (data)
                            setBeneficio(data[0]);
                    }
                });

            paymentService.existenPagosPendientesImputacion().then(
                (result: any) => {
                    if (result.success) {
                        setExistenPagosPendientesImputacion(result.data)
                    } else {
                        setError(result.errors[0]);
                    }
                }
            );
        }

        fetchData();
    }, []);

    const handleVerCredencial = async () => {
        try {
            const legajo = user?.datosUsuario?.legajoPrevisional;

            if (!legajo) {
                setShowCredentialModal(true);
                return;
            }

            const picture = await userService.getProfilePicture(String(legajo));

            const hasProfileImage =
                picture instanceof ArrayBuffer
                    ? picture.byteLength > 0
                    : !!picture;

            if (!hasProfileImage) {
                setShowCredentialModal(true);
                return;
            }

            navigate('/credencial');
        } catch (error) {
            setShowCredentialModal(true);
        }
    }

    const handleMinutaTasacion = async () => {
        try {
            const codigoColegio = user?.datosUsuario?.codigoColegioActual;
            setLoading(true);
            const response = await colegioService.descargarMinutaTasacion(codigoColegio || '');
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
        } catch (error) {
            console.error("Error al descargar la minuta", error);
        } finally {
            setLoading(false);
        }
    }

    return (
        user ?
            <DefaultLayout>
                {/* Loading */}
                {loading ? <Loading statusText={"Cargando"} /> : null}

                <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6 xl:grid-cols-2 2xl:gap-7.5">

                    {/*Estdo de cuenta*/}
                    {!user?.datosUsuario?.beneficiario && (
                        <div className="bg-white dark:bg-boxdark p-4 rounded-2xl border border-gray">
                            <p className="text-title-sm dark:text-white mb-6">Estado de cuenta</p>
                            {
                                loading ? <p className="mt-2 text-sm dark:text-white">Cargando...</p>
                                    :
                                    deudaAfiliado ?
                                        <>
                                            {deudaAfiliado?.montoTotal > 0 ?
                                                (
                                                    <div className="mt-2">
                                                        <div className="text-primario-azul-900 dark:text-white text-title-xl font-bold">
                                                            {toCurrency(deudaAfiliado?.montoTotal)}
                                                        </div>

                                                        {deudaAfiliado.fechaProceso &&
                                                            <div className="text-secondary text-sm">
                                                                Saldo pendiente al {(new Date(deudaAfiliado.fechaProceso)).toLocaleDateString()}
                                                            </div>
                                                        }

                                                        {existenPagosPendientesImputacion ?
                                                            <div className="mt-2 text-warning">
                                                                Este saldo podría actualizarse en breve ya que existen pagos pendientes de imputación
                                                            </div> :
                                                            null
                                                        }
                                                    </div>
                                                ) : (
                                                    <div className="mt-2">
                                                        <div className="text-title-xl mt-4">
                                                            ¡Estás al día!
                                                        </div>

                                                        <div className="text-secondary mt-4">
                                                            No tenés aportes pendientes
                                                        </div>
                                                    </div>
                                                )}
                                        </> :
                                        <>
                                            {user?.datosUsuario?.beneficiario ?
                                                <>
                                                    <div className="text-title-xl mt-4">
                                                        ¡Estás al día!
                                                    </div>
                                                    <div className="text-secondary">
                                                        No tenés aportes pendientes
                                                    </div>
                                                </>
                                                :
                                                <div className="text-title-md mt-4">
                                                    No Disponible
                                                </div>
                                            }
                                        </>
                            }

                            {!user?.datosUsuario?.beneficiario ?
                                <div className="mt-4">
                                    <hr className="border-gray-2" />
                                    <div className="flex mt-4 gap-4">
                                        <button
                                            onClick={() => navigate('/pagos/movimientos')}
                                            className="w-48 py-3 px-3 bg-transparent hover:bg-primario-celeste-800 text-primario-celeste-800 font-semibold hover:text-white py-2 px-4 border border-primario-celeste-800 hover:border-transparent rounded"
                                        >
                                            Mis Moviemientos
                                        </button>
                                        <button
                                            disabled={!deudaAfiliado?.montoTotal}
                                            onClick={() => navigate('/pagos/pagar')}
                                            className="disabled:opacity-50 w-48 py-3 px-3 bg-primario-celeste-800 hover:bg-primario-azul-900 text-white font-semibold hover:text-white py-2 px-4 border border-primario-celeste-800 hover:border-transparent rounded">
                                            Pagar
                                        </button>
                                    </div>
                                </div>
                                : null
                            }
                        </div>
                    )}

                    {/* Credencial digital */}
                    <div className="bg-white dark:bg-boxdark p-4 rounded-2xl border border-gray">
                        <p className="text-title-sm dark:text-white">Credencial Digital</p>
                        <div className="text-secondary mt-4">
                            Accedé a tu credencial profesional digital
                        </div>
                        <div className="mt-4 flex space-x-4">
                            <div className="mt-20">
                                <button
                                    onClick={handleVerCredencial}
                                    className="w-48 py-3 px-3 bg-transparent hover:bg-primario-celeste-800 text-primario-celeste-800 font-semibold hover:text-white py-2 px-4 border border-primario-celeste-800 hover:border-transparent rounded">
                                    Ver credencial
                                </button>
                            </div>
                            <div className="w-full flex justify-end pr-45">
                                <img
                                    src={CredencialImg}
                                    alt="Credencial"
                                    className="w-36 h-auto rounded shadow-sm"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Trámites */}
                <div className="grid grid-cols-1 gap-4 md:gap-6 2xl:gap-7.5">
                    <div className="mt-6 bg-white dark:bg-boxdark p-4 rounded-2xl border border-gray">
                        <p className="text-title-sm dark:text-white">Trámites</p>

                        <div className="mt-6 grid grid-cols-3 md:grid-cols-5 gap-4 md:gap-9 pb-4">

                            {/*SOLO AFILIADOS*/}
                            {!user?.datosUsuario?.beneficiario ?
                                <>
                                    <TramiteButton
                                        label="Pagar boleta"
                                        icon={<FaMoneyCheckAlt />}
                                        onClick={() => navigate('/pagos/boleta')}
                                        alert={false}
                                    />

                                    <TramiteButton
                                        label="Informar transferencia"
                                        icon={<FaUpload />}
                                        onClick={() => navigate('/pagos/transferencia')}
                                    />

                                    <TramiteButton
                                        label="Minuta de tasación"
                                        icon={<FaFile />}
                                        onClick={handleMinutaTasacion}
                                    />
                                </> : null
                            }

                            <TramiteButton
                                label="Congresos y eventos"
                                icon={<FaTicketAlt />}
                                onClick={() => navigate('/mi-autogestion/entradas')}
                            />
                            <TramiteButton
                                label="Colegios departamentales"
                                icon={<FaMapMarkedAlt />}
                                onClick={() => navigate('/ColegiosDepartamentales')}
                            />
                            <TramiteButton
                                label="Préstamos"
                                icon={<FaPiggyBank />}
                                onClick={() => navigate('/prestamos')}
                            />

                            {/*SOLO BNEFICIARIOS*/}
                            {user?.datosUsuario?.beneficiario ?
                                <>
                                    <TramiteButton
                                        label="Supervivencia"
                                        icon={<FaIdCard />}
                                        onClick={() => navigate('/supervivencia')}
                                    //alert={true}
                                    //badgeCount={1}
                                    />

                                    <TramiteButton
                                        label="Recibos de haberes"
                                        icon={<FaFile />}
                                        onClick={() => navigate('/recibos')}
                                    />
                                </> : null
                            }

                            <TramiteButton
                                label="Beneficios"
                                icon={<FaGift />}
                                onClick={() => navigate('/beneficios')}
                            />

                            <TramiteButton
                                label="Contáctanos"
                                icon={<FaPhone />}
                                onClick={() => navigate('/contacto')}
                            />
                        </div>
                    </div>
                </div>

                {/* Widget de Congresos y Eventos */}
                <div className="mt-6">
                    <CongresosHomeWidget />
                </div>

                {/* Beneficios */}
                <div className="mt-6 bg-white dark:bg-boxdark p-4 rounded-2xl border border-gray md:w-1/2">
                    {beneficio && <p className="text-title-sm dark:text-white">{beneficio.title}</p>}

                    {beneficio &&
                        <div
                            onClick={() => navigate("/beneficios")}
                            style={{
                                marginBottom: 20,
                                cursor: "pointer",
                            }}
                        >
                            <img
                                src={beneficio.image}
                                alt="Beneficio"
                                style={{
                                    width: "100%",
                                    height: 150,
                                    objectFit: "contain",
                                    marginTop: 20,
                                }}
                            />
                        </div>
                    }
                </div>

                {/* Modal para credencial sin imagen */}
                {showCredentialModal && (
                    <div className="fixed inset-0 z-99999 flex items-center justify-center bg-black/50">
                        <div className="w-full max-w-md rounded-xl bg-white p-6 shadow-lg">
                            <h3 className="mb-3 text-lg font-semibold text-gray-900">Credencial digital</h3>
                            <p className="text-sm text-gray-700">
                                No se puede abrir la credencial porque no tiene una imagen cargada.
                                Actualiza tu imagen desde la edición de perfil.
                            </p>
                            <div className="mt-6 flex justify-end">
                                <button
                                    onClick={() => setShowCredentialModal(false)}
                                    className="rounded bg-primario-celeste-800 px-4 py-2 text-white hover:bg-primario-azul-900">
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                )}

            </DefaultLayout >
            :
            null
    );
};

export default Home;
